const DrinksIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.87268 14.9565L4.69088 5.97823C4.60157 5.30503 4.75363 5.16626 5.49917 5.16626H13.4336C14.1792 5.16626 14.3298 5.30503 14.2412 5.97823L13.0594 14.9565C12.8985 16.1781 12.818 16.7893 12.3552 17.1562C11.3978 17.9172 7.49293 17.8847 6.57688 17.1562C6.11405 16.7893 6.03359 16.1781 5.87268 14.9565Z"
				stroke="currentColor"
				strokeWidth="0.88579"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.9375 15.5004L11.2667 3.64627C11.2778 3.4584 11.3603 3.28186 11.4972 3.15275C11.6341 3.02364 11.8152 2.95171 12.0034 2.95166H14.9981"
				stroke="currentColor"
				strokeWidth="0.88579"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.40234 8.85706C5.53669 8.61125 5.97958 8.1189 6.9451 8.1189C8.15346 8.1189 7.83458 8.85706 8.63991 8.85706C9.44524 8.85706 10.6536 8.1189 11.8612 8.1189C13.0689 8.1189 13.8912 8.85706 13.8912 8.85706M8.36162 13.286H8.35498"
				stroke="currentColor"
				strokeWidth="0.88579"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default DrinksIcon;
